import { render } from "./UnsplashTag.vue?vue&type=template&id=3e0fb1c2&scoped=true"
const script = {}

import "./UnsplashTag.vue?vue&type=style&index=0&id=3e0fb1c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0fb1c2"]])

export default __exports__